/* eslint-disable no-undef */
// import { post } from 'axios';
import {
  postApi,
  postApiHttp,
  postApiToJson,
  postApiToKakao,
  postApiToNaver,
  postSessionCheck,
} from "./Network";
import { AppContext } from "../../components/AppProvider";
import { getCookie } from "../utils/cookie";
import { async } from "regenerator-runtime";
import { Base64 } from "js-base64";

export const PostApi999 = async (phonecfg, cfg, userToken) => {
  const url = cfg.url + "999";

  const formData = new FormData();
  formData.append("userToken", userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123" ? getCookie("phoneToken") : phonecfg.phoneToken
  );
  // formData.append('phoneToken', '123');
  formData.append("phoneOS", phonecfg.phoneOS);

  return postApi(url, formData);
};

// 일반로그인
export const PostApi101 = async (phonecfg, cfg, email, password, UID, signUpChannel) => {
  const url = cfg.url + "101";

  const formData = new FormData();

  if (email && email != undefined && email != "" && email != "undefined") {
    formData.append("userId", email);
  }
  formData.append("userPassword", password);
  formData.append("UID", UID);
  formData.append("signUpChannel", signUpChannel);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123" ? getCookie("phoneToken") : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  // formData.append("phoneModel", getCookie("modelName"));
  // formData.append("phoneOSVers", getCookie("osVer"));
  formData.append("phoneModel", phonecfg.modelName);
  formData.append("phoneOSVers", phonecfg.osVer);
  // formData.append("phoneModel", "TEST_MODEL");
  // formData.append("phoneOSVers", "TEST_OS");

  return postApi(url, formData);
};

// 회원가입
export const PostApi102 = async (
  phonecfg,
  cfg,
  email,
  password,
  name,
  signUpChannel,
  userInfo,
  msgYn,
  isForeigner
) => {
  const url = cfg.url + "102";

  const formData = new FormData();
  formData.append("userId", email);
  formData.append("userPassword", password);
  formData.append("userName", name);
  formData.append("userPhone", userInfo.userPhone);
  formData.append(
    "signUpChannel",
    signUpChannel === "500" ? "000" : signUpChannel
  );
  formData.append("birth", userInfo.userBirth);
  formData.append("Gender", userInfo.Gender);
  formData.append("msgYn", msgYn);
  formData.append("ownYn", userInfo.userDI ? "Y" : "N");
  formData.append("isForeigner", isForeigner ? isForeigner : 0);

  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("phoneModel", phonecfg.modelName);
  formData.append("phoneOSVers", phonecfg.osVer);

  // 본인인증 결과값 없으면 안보내기로 변경
  if (signUpChannel != "500") {
    userInfo.userDI &&
      formData.append("userDI", userInfo.userDI ? userInfo.userDI : "");
    userInfo.authDate && formData.append("authDate", userInfo.authDate);
    userInfo.userCI && formData.append("userCI", userInfo.userCI);
  }
  formData.append("isAuthOk", signUpChannel != "500" ? "0" : "9");

  return postApi(url, formData);
};

export const PostApi104 = async (
  cfg,
  userToken,
  userDI,
  authDate,
  userName,
  userBirth,
  Gender,
  userPhone,
  isForeigner
) => {
  const url = cfg.url + "104";

  const formData = new FormData();
  formData.append("userToken", userToken);
  formData.append("userDI", userDI);
  formData.append("authDate", authDate);
  formData.append("userName", userName);
  formData.append("userBirth", userBirth);
  formData.append("Gender", Gender);
  formData.append("userPhone", userPhone);
  formData.append("isForeigner", isForeigner);

  return postApi(url, formData);
};

export const PostApi102Sns = async (phonecfg, cfg, email, name, signUpChannel, UID, userInfo) => {
  const url = cfg.url + "102";
  let phoneToken = phonecfg.phoneToken;

  if (!phoneToken) {
    phoneToken = getCookie("phoneToken");
  }

  if (phoneToken === "123" || phoneToken === undefined || phoneToken === "undefined") {
    phoneToken = getCookie("phoneToken");
  }
  
  const formData = new FormData();

  if (email && email != undefined && email != "" && email != "undefined" && email != "null") {
    formData.append("userEmail", email);
  }
  formData.append("userName", name);
  formData.append("userPhone", userInfo.userPhone);
  formData.append("signUpChannel", signUpChannel);
  formData.append("UID", UID);
  formData.append("phoneToken", phoneToken);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  // formData.append("phoneModel", getCookie("modelName"));
  // formData.append("phoneOSVers", getCookie("osVer"));
  formData.append("phoneModel", phonecfg.modelName);
  formData.append("phoneOSVers", phonecfg.osVer);

  formData.append("userDI", userInfo.userDI);
  formData.append("authDate", userInfo.authDate);
  formData.append("birth", userInfo.userBirth);
  formData.append("Gender", userInfo.Gender);
  formData.append("userCI", userInfo.userCI);
  formData.append("isAuthOk", "0");
  formData.append("ownYn", "Y");
  formData.append("isForeigner", userInfo.isForeigner ? userInfo.isForeigner : 0 );

  return postApi(url, formData);
};

export const PostApi108 = async (userinfo, cfg, phonecfg) => {
  const url = cfg.url + "108";

  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123" ? getCookie("phoneToken") : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  return postApi(url, formData);
};

export const PostApi150 = async (cfg, userDI) => {
  const url = cfg.url + "150";

  const formData = new FormData();
  formData.append("userDI", userDI);

  return postApi(url, formData);
};

// 회원가입 여부 확인
export const PostApi151 = async (phonecfg, cfg, email) => {
  const url = cfg.url + "151";

  const formData = new FormData();
  formData.append("userId", email);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123" ? getCookie("phoneToken") : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  return postApi(url, formData);
};

// 본인 인증 사용자 확인
export const PostApi152 = async (
  phonecfg,
  cfg,
  authKey,
  userEmail,
  userName,
  userBirth,
  userGender,
  userPhone
) => {
  const url = cfg.url + "152";

  const formData = new FormData();
  formData.append("authkey", authKey);
  formData.append("userEmail", userEmail);
  formData.append("userName", userName);
  formData.append("userBirth", userBirth);
  formData.append("Gender", userGender);
  formData.append("userPhone", userPhone);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123" ? getCookie("phoneToken") : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  return postApi(url, formData);
};

export const PostApi154 = async (
  phonecfg,
  cfg,
  userNm,
  userTelNo,
  userBirth,
  gender,
  userDI,
  userToken,
  isForeigner
) => {
  const url = cfg.url + "154";

  const formData = new FormData();
  formData.append("userNm", userNm);
  formData.append("userTelNo", userTelNo);
  formData.append("userBirthDt", userBirth);
  formData.append("userSex", gender);
  formData.append("userDI", userDI);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123" ? getCookie("phoneToken") : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  userToken && userToken != "" && formData.append("userToken", userToken);
  isForeigner && isForeigner != ""
    ? formData.append("fornrYn", isForeigner)
    : formData.append("fornrYn", 0);

  return postApi(url, formData);
};

// 회원상태 확인
export const PostApi155 = async (phonecfg, cfg, userinfo) => {
  const url = cfg.url + "155";

  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123" ? getCookie("phoneToken") : phonecfg.phoneToken
  );

  formData.append("phoneOS", phonecfg.phoneOS);

  if (phonecfg.version != "2.0.0") {
    formData.append("appVer", phonecfg.version);
  }

  // formData.append("phoneModel", getCookie("modelName"));
  // formData.append("phoneOSVers", getCookie("osVer"));

  formData.append("phoneModel", phonecfg.modelName);
  formData.append("phoneOSVers", phonecfg.osVer);

  return postApi(url, formData);
};

// 인증번호 생성
export const PostApi156 = async (
  phonecfg,
  cfg,
  userId,
  userNm,
  userBirthDt,
  userTelNo,
  userSex
) => {
  const url = cfg.url + "156";

  const formData = new FormData();
  formData.append("phoneToken", phonecfg.phoneToken);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("userId", userId);
  formData.append("userNm", userNm);
  formData.append("userBirthDt", userBirthDt);
  formData.append("userTelNo", userTelNo);
  formData.append("userSex", userSex);

  return postApi(url, formData);
};

// 인증번호 확인
export const PostApi157 = async (
  phonecfg,
  cfg,
  userId,
  userNm,
  userBirthDt,
  userTelNo,
  attctNo
) => {
  const url = cfg.url + "157";

  const formData = new FormData();
  formData.append("phoneToken", phonecfg.phoneToken);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("userId", userId);
  formData.append("userNm", userNm);
  formData.append("userBirthDt", userBirthDt);
  formData.append("userTelNo", userTelNo);
  formData.append("attctNo", attctNo);

  return postApi(url, formData);
};

// 비밀번호 재설정(인증번호)
export const PostApi158 = async (phonecfg, cfg, userId, userPswdNo, attctNo) => {
  const url = cfg.url + "158";

  const formData = new FormData();
  formData.append("phoneToken", phonecfg.phoneToken);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("userId", userId);
  formData.append("userPswdNo", userPswdNo);
  formData.append("attctNo", attctNo);

  return postApi(url, formData);
};

// 병원 인증번호 회원가입 관련
export const PostApi160 = async (phonecfg, cfg, userNm, userBirthDt, userTelNo, userSex) => {
  const url = cfg.url + "160";

  const formData = new FormData();
  formData.append("userNm", userNm);
  formData.append("userBirthDt", userBirthDt);
  formData.append("userTelNo", userTelNo);
  formData.append("userSex", userSex);

  formData.append("phoneToken", phonecfg.phoneToken);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  return postApi(url, formData);
};

export const PostApi161 = async (phonecfg, cfg, userNm, userBirthDt, userTelNo, userSex, hpKey) => {
  const url = cfg.url + "161";

  const formData = new FormData();
  formData.append("userNm", userNm);
  formData.append("userBirthDt", userBirthDt);
  formData.append("userTelNo", userTelNo);
  formData.append("userSex", userSex);
  formData.append("hpKey", hpKey);

  formData.append("phoneToken", phonecfg.phoneToken);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  return postApi(url, formData);
};

export const PostApi162 = async (
  phonecfg,
  cfg,
  userToken,
  userNm,
  userBirthDt,
  userTelNo,
  userSex
) => {
  const url = cfg.url + "162";

  const formData = new FormData();
  formData.append("userToken", userToken);
  formData.append("userNm", userNm);
  formData.append("userBirthDt", userBirthDt);
  formData.append("userTelNo", userTelNo);
  formData.append("userSex", userSex);

  formData.append("phoneToken", phonecfg.phoneToken);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  return postApi(url, formData);
};

// 전자처방전 조제/접수
export const PostApi201 = async (userinfo, cfg, phonecfg, pxid, phKey, pxStatus) => {
  const url = cfg.url + "201";

  const formData = new FormData();
  formData.append("userToken", !userinfo.userToken ? getCookie("userToken") : userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123" ? getCookie("phoneToken") : phonecfg.phoneToken
  );
  formData.append("pxid", pxid);
  formData.append("phKey", phKey);
  formData.append("pxStatus", pxStatus);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  return postApi(url, formData);
};

// 종이처방전 등록
export const PostApi202 = async (
  userinfo,
  cfg,
  phonecfg,
  prescriptionDate,
  preparationDate,
  hospitalName,
  pharmacyName,
  filePath
) => {
  const url = cfg.url + "202";

  const formData = new FormData();
  formData.append("prescriptionDate", prescriptionDate);
  formData.append("preparationDate", preparationDate);
  formData.append("hospitalName", hospitalName);
  formData.append("pharmacyName", pharmacyName);
  formData.append("filePath", filePath);
  formData.append("userToken", !userinfo.userToken ? getCookie("userToken") : userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123" ? getCookie("phoneToken") : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  return postApi(url, formData);
};

// My약국 등록/삭제
export const PostApi203 = async (userinfo, cfg, phonecfg, phKey, myPharmacy) => {
  const url = cfg.url + "203";

  const formData = new FormData();
  formData.append("userToken", !userinfo.userToken ? getCookie("userToken") : userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123" ? getCookie("phoneToken") : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("phKey", phKey);
  formData.append("status", myPharmacy === "1" ? "0" : "1");

  return postApi(url, formData);
};

// 전자처방전 접수 취소
export const PostApi204 = async (userinfo, cfg, phonecfg, pxid) => {
  const url = cfg.url + "204";

  const formData = new FormData();
  formData.append("userToken", !userinfo.userToken ? getCookie("userToken") : userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123" ? getCookie("phoneToken") : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("pxid", pxid);

  return postApi(url, formData);
};

export const PostApi205 = async (userinfo, cfg, phonecfg, pxid, paperFlag) => {
  const url = cfg.url + "205";

  const formData = new FormData();
  formData.append("userToken", !userinfo.userToken ? getCookie("userToken") : userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123" ? getCookie("phoneToken") : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("pxid", pxid);
  formData.append("paperFlag", paperFlag);

  return postApi(url, formData);
};

// 등록된 알레르기 등록
export const PostApi211 = async (
  userinfo,
  cfg,
  phonecfg,
  allergyType,
  foodId,
  medicineId,
  symptomDT,
  symptomType,
  symptomInfo
) => {
  const url = cfg.url + "211";

  const formData = new FormData();
  formData.append("userToken", !userinfo.userToken ? getCookie("userToken") : userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123" ? getCookie("phoneToken") : phonecfg.phoneToken
  );
  formData.append("allergyType", allergyType);
  formData.append("foodid", foodId);
  formData.append("medicineId", medicineId);
  formData.append("symptomDT", symptomDT);
  formData.append("symptomType", symptomType);
  formData.append("symptomInfo", symptomInfo);

  return postApi(url, formData);
};

// 등록된 알레르기 삭제
export const PostApi213 = async (userinfo, cfg, phonecfg, allergyId, allergyType) => {
  const url = cfg.url + "213";

  const formData = new FormData();
  formData.append("userToken", !userinfo.userToken ? getCookie("userToken") : userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123" ? getCookie("phoneToken") : phonecfg.phoneToken
  );
  formData.append("allergyId", allergyId);
  formData.append("allergyType", allergyType);

  return postApi(url, formData);
};

// 사용자 약품, 식품, 기타 알레르기 등록
export const PostApi214 = async (
  userinfo,
  cfg,
  phonecfg,
  allergyType,
  foodId,
  foodName,
  symptomDT,
  symptomType,
  symptomInfo
) => {
  const url = cfg.url + "214";

  const formData = new FormData();
  formData.append("userToken", !userinfo.userToken ? getCookie("userToken") : userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123" ? getCookie("phoneToken") : phonecfg.phoneToken
  );
  formData.append("allergyType", allergyType);
  formData.append("foodid", foodId);
  formData.append("foodName", foodName);
  formData.append("symptomDT", symptomDT);
  formData.append("symptomType", symptomType);
  formData.append("symptomInfo", symptomInfo);

  return postApi(url, formData);
};

// 사용자 약품, 식품, 기타 알레르기 등록
export const PostApi216 = async (
  userinfo,
  cfg,
  phonecfg,
  allergyId,
  allergyType,
  foodId,
  symptomDT,
  symptomType,
  symptomInfo
) => {
  const url = cfg.url + "216";

  const formData = new FormData();
  formData.append("userToken", !userinfo.userToken ? getCookie("userToken") : userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123" ? getCookie("phoneToken") : phonecfg.phoneToken
  );
  formData.append("allergyId", allergyId);
  formData.append("allergyType", allergyType);
  formData.append("foodid", foodId);
  formData.append("symptomDT", symptomDT);
  formData.append("symptomType", symptomType);
  formData.append("symptomInfo", symptomInfo);

  return postApi(url, formData);
};

export const PostApi221 = async (userinfo, cfg, phonecfg, params) => {
  const url = cfg.url + "221";
  const formData = new FormData();
  formData.append(
    "userToken",
    !userinfo.userToken ? getCookie("userToken") : userinfo.userToken
  );
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  params.seqNo
    ? formData.append("seqNo", params.seqNo)
    : formData.append("seqNo", "");
  formData.append("hpKey", params.hpKey);
  formData.append("license", params.license);
  formData.append("appDrName", params.appDrName);
  formData.append("appHour", params.appHour);
  formData.append("appCls", params.appCls);

  params.symtmDesc && formData.append("symtmDesc", params.symtmDesc);
  params.symtmString && formData.append("symtmString", params.symtmString);
  params.cardSeqNo && formData.append("cardSeqNo", params.cardSeqNo);
  formData.append(
    "idCardFileNm",
    params.idCardFileNm ? params.idCardFileNm : ""
  );
  formData.append(
    "idCardEncFile",
    params.idCardEncFile ? params.idCardEncFile : ""
  );

  formData.append("rqstRelCd", params.rqstRelCd ? params.rqstRelCd : "PRCP");

  formData.append(
    "famzSeqNo",
    params.famzSeqNo && params.famzSeqNo != "" ? params.famzSeqNo : 0
  );
  // formData.append("famzSeqNo", params.famzSeqNo);

  formData.append("phKey", params.phKey ? params.phKey : "");
  formData.append("pharmName", params.pharmName ? params.pharmName : "");
  formData.append("pharmTelNo", params.pharmTelNo ? params.pharmTelNo : "");
  formData.append("pharmFaxNum", params.pharmFaxNum ? params.pharmFaxNum : "");
  formData.append("issueCpnNo", params.issueCpnNo ? params.issueCpnNo : "");

  return postApi(url, formData);
};

// 접수처리API
export const PostApi222 = async (userinfo, cfg, phonecfg, appIdx) => {
  const url = cfg.url + "222";

  const formData = new FormData();
  formData.append(
    "userToken",
    !userinfo.userToken ? getCookie("userToken") : userinfo.userToken
  );
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("appID", appIdx);
  formData.append("appStatus", "9");

  return postApi(url, formData);
};

// 접수확정(전화)
export const PostApi223 = async (
  userinfo,
  cfg,
  phonecfg,
  appIdx,
  appStatus,
  payStatus
) => {
  const url = cfg.url + "223";

  const formData = new FormData();
  formData.append(
    "userToken",
    !userinfo.userToken ? getCookie("userToken") : userinfo.userToken
  );
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("appID", appIdx);
  formData.append("appStatus", appStatus);
  formData.append("payStatus", payStatus);

  return postApi(url, formData);
};

export const PostApi224 = async (
  userinfo,
  cfg,
  phonecfg,
  seqNo,

  phKey,
  pharmName,
  pharmFaxNum,
  pharmTelNo
) => {
  const url = cfg.url + "224";

  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("seqNo", seqNo);

  formData.append("phKey", phKey || phKey == "null" ? phKey : "");
  formData.append("pharmName", pharmName);
  formData.append("pharmFaxNum", pharmFaxNum);
  formData.append("pharmTelNo", pharmTelNo);

  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  return postApi(url, formData);
};

export const PostApi225 = async (userinfo, cfg, phonecfg, seqNo) => {
  const url = cfg.url + "225";

  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("seqNo", seqNo);

  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  return postApi(url, formData);
};

export const PostApi226 = async (userinfo, cfg, phonecfg, seqNo) => {
  const url = cfg.url + "226";

  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("seqNo", seqNo);

  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  return postApi(url, formData);
};

export const PostApi227 = async (userinfo, cfg, phonecfg, seqNo, cardSeqNo) => {
  const url = cfg.url + "227";

  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("seqNo", seqNo);
  formData.append("cardSeqNo", cardSeqNo);

  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  return postApi(url, formData);
};

export const PostApi251 = async (userinfo, cfg, phonecfg) => {
  const url = cfg.url + "251";
  const formData = new FormData();
  formData.append(
    "userToken",
    !userinfo.userToken ? getCookie("userToken") : userinfo.userToken
  );
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );

  return postApi(url, formData);
};

export const PostApi252 = async (
  userinfo,
  cfg,
  phonecfg,
  pxFlag,
  startDate,
  endDate,
  pageIdx
) => {
  const url = cfg.url + "252";

  const formData = new FormData();
  formData.append(
    "userToken",
    !userinfo.userToken ? getCookie("userToken") : userinfo.userToken
  );
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("startDate", startDate);
  // formData.append('startDate', '20210101');
  formData.append("endDate", endDate);
  formData.append("pxFlag", pxFlag === 0 ? 1 : 2);
  // formData.append('pageNo', pageIdx);
  // formData.append('pageCnt', '10');

  return postApi(url, formData);
};

export const PostApi254 = async (userinfo, cfg, phonecfg) => {
  const url = cfg.url + "254";

  const formData = new FormData();
  formData.append(
    "userToken",
    !userinfo.userToken ? getCookie("userToken") : userinfo.userToken
  );
  formData.append("userLat", phonecfg.userLat);
  formData.append("userLng", phonecfg.userLng);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  // formData.append('pageNo', '');
  // formData.append('pageCnt', '');
  formData.append("sortCond", "1");

  return postApi(url, formData);
};

export const PostApi255 = async (userinfo, cfg, phonecfg) => {
  const url = cfg.url + "255";

  const formData = new FormData();
  formData.append(
    "userToken",
    !userinfo.userToken ? getCookie("userToken") : userinfo.userToken
  );
  formData.append("userLat", phonecfg.userLat);
  formData.append("userLng", phonecfg.userLng);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  // formData.append("pageNo", "1");
  // formData.append("pageCnt", "10");
  formData.append("sortCond", "1");

  return postApi(url, formData);
};

export const PostApi256 = async (
  userinfo,
  cfg,
  phonecfg,
  searchPharmacyName,
  searchAddress
) => {
  const url = cfg.url + "256";

  const formData = new FormData();
  formData.append("searchPhname", searchPharmacyName);
  formData.append("searchValue", searchAddress);
  formData.append("searchCondition", "");
  formData.append("userToken", userinfo.userToken);
  formData.append("userLat", phonecfg.userLat);
  formData.append("userLng", phonecfg.userLng);
  formData.append(
    "userToken",
    !userinfo.userToken ? getCookie("userToken") : userinfo.userToken
  );
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  // formData.append('pageNo', '1');
  // formData.append('pageCnt', '10');
  formData.append("sortCond", "1");

  return postApi(url, formData);
};

// 알레르기 목록
export const PostApi261 = async (userinfo, cfg, phonecfg, allergyType) => {
  const url = cfg.url + "261";

  const formData = new FormData();
  formData.append(
    "userToken",
    !userinfo.userToken ? getCookie("userToken") : userinfo.userToken
  );
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("allergyType", allergyType);

  return postApi(url, formData);
};

// 관련약품
export const PostApi262 = async (
  userinfo,
  cfg,
  phonecfg,
  medicineId,
  searchValue,
  allergyType,
  pageNo,
  pageCnt
) => {
  const url = cfg.url + "262";

  const formData = new FormData();
  formData.append(
    "userToken",
    !userinfo.userToken ? getCookie("userToken") : userinfo.userToken
  );
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("medicineId", medicineId);
  formData.append("searchValue", searchValue);
  formData.append("allergyType", allergyType);
  formData.append("pageNo", pageNo);
  formData.append("pageCnt", pageCnt);

  return postApi(url, formData);
};

// 약품상세내역
export const PostApi263 = async (
  userinfo,
  cfg,
  phonecfg,
  medicineId,
  pageNo,
  pageCnt
) => {
  const url = cfg.url + "263";

  const formData = new FormData();
  formData.append(
    "userToken",
    !userinfo.userToken ? getCookie("userToken") : userinfo.userToken
  );
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("medicineId", medicineId);
  formData.append("pageNo", pageNo);
  formData.append("pageCnt", pageCnt);

  return postApi(url, formData);
};

// 약품상세내역2
export const PostApi264 = async (
  userinfo,
  cfg,
  phonecfg,
  allergyType,
  foodId,
  pageNo,
  pageCnt
) => {
  const url = cfg.url + "264";

  const formData = new FormData();
  formData.append(
    "userToken",
    !userinfo.userToken ? getCookie("userToken") : userinfo.userToken
  );
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("allergyType", allergyType);
  formData.append("foodid", foodId);
  formData.append("pageNo", pageNo);
  formData.append("pageCnt", pageCnt);

  return postApi(url, formData);
};

// 예약목록API
export const PostApi271 = async (userinfo, cfg, phonecfg, startDt, endDt) => {
  const url = cfg.url + "271";

  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("startDate", startDt);
  formData.append("endDate", endDt);
  return postApi(url, formData);
};

// 병원목록API
export const PostApi272 = async (userinfo, cfg, phonecfg, lastIndex) => {
  const url = cfg.url + "272";

  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("userLat", phonecfg.userLat);
  formData.append("userLng", phonecfg.userLng);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("pageNo", lastIndex);
  formData.append("pageCnt", 30);
  formData.append("sortCond", 1);
  return postApi(url, formData);
};

// 병원목록API
export const PostApi273 = async (
  userinfo,
  cfg,
  phonecfg,
  searchType,
  hpNm,
  hpAddr,
  index
) => {
  const url = cfg.url + "273";

  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  formData.append("userLat", phonecfg.userLat);
  formData.append("userLng", phonecfg.userLng);

  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("searchType", searchType);
  formData.append("hpNm", hpNm);
  formData.append("hpAddr", hpAddr);
  formData.append("pageNo", index);
  formData.append("pageCnt", 30);
  formData.append("sortCond", 1);
  return postApi(url, formData);
};

// 병원검색
export const PostApi274 = async (
  userinfo,
  cfg,
  phonecfg,
  searchType,
  hpNm,
  hpAddr,
  index
) => {
  const url = cfg.url + "274";

  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  if (phonecfg.userLat && phonecfg.userLng) {
    formData.append("userLat", phonecfg.userLat);
    formData.append("userLng", phonecfg.userLng);
  } else {
    formData.append("userLng", 0);
    formData.append("userLat", 0);
  }

  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("searchType", searchType);
  formData.append("searchHpName", hpNm);
  formData.append("searchValue", hpAddr);
  formData.append("pageNo", index);
  formData.append("pageCnt", 30);
  formData.append("sortCond", 1);
  return postApi(url, formData);
};

export const PostApi278 = async (
  userinfo,
  cfg,
  phonecfg,
  searchType,
  hpNm,
  hpAddr
) => {
  const url = cfg.url + "278";

  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  if (phonecfg.userLat && phonecfg.userLng) {
    formData.append("userLat", phonecfg.userLat);
    formData.append("userLng", phonecfg.userLng);
  } else {
    formData.append("userLng", 0);
    formData.append("userLat", 0);
  }

  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("searchType", searchType);
  formData.append("searchHpName", hpNm);
  formData.append("searchValue", hpAddr);
  // formData.append('pageNo', 1);
  // formData.append('pageCnt', 10);
  formData.append("orderBy", 1);
  return postApi(url, formData);
};

// 의사목록API
export const PostApi275 = async (userinfo, cfg, phonecfg, hpKey) => {
  const url = cfg.url + "275";

  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("userLat", phonecfg.userLat);
  formData.append("userLng", phonecfg.userLng);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("hpKey", hpKey);
  return postApi(url, formData);
};

export const PostApi276 = async (
  userinfo,
  cfg,
  phonecfg,
  hpKey,
  license,
  appHour,
  appCls
) => {
  const url = cfg.url + "276";

  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("userLat", phonecfg.userLat);
  formData.append("userLng", phonecfg.userLng);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("hpKey", hpKey);
  formData.append("license", license);
  formData.append("appHour", appHour);
  formData.append("appCls", appCls);
  return postApi(url, formData);
};

export const PostApi501 = async (userinfo, cfg, trsmId) => {
  const url = cfg.url + "501";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("trsmId", trsmId);
  formData.append("fileIndex", "1");

  return postApi(url, formData);
};

export const PostApi503 = async (userinfo, cfg, phonecfg, trsmId) => {
  const url = cfg.url + "503";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("trsmId", trsmId);

  return postApi(url, formData);
};

export const PostApi551 = async (
  userinfo,
  cfg,
  phonecfg,
  hpCode,
  modalityName,
  startDate,
  endDate,
  pdhType,
  downFlag,
  pageCnt,
  pageNo
) => {
  const url = cfg.url + "551";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("hpCode", hpCode);
  formData.append("modalityName", modalityName);
  formData.append("pdhType", pdhType);
  formData.append("startDate", startDate);
  formData.append("endDate", endDate);
  formData.append("downFlag", downFlag);
  formData.append("pageCnt", pageCnt);
  formData.append("pageNo", pageNo);

  return postApi(url, formData);
};

// 병원리스트 가져오기
export const PostApi554 = async (
  userinfo,
  cfg,
  phonecfg,
  pdhType,
  startDate,
  endDate
) => {
  const url = cfg.url + "554";

  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("pdhType", pdhType);
  formData.append("startDate", startDate);
  formData.append("endDate", endDate);

  return postApi(url, formData);
};

// 검사장비 가져오기
export const PostApi555 = async (
  userinfo,
  cfg,
  phonecfg,
  pdhType,
  startDate,
  endDate
) => {
  const url = cfg.url + "555";

  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("pdhType", pdhType);
  formData.append("startDate", startDate);
  formData.append("endDate", endDate);
  return postApi(url, formData);
};

export const PostApi556 = async (userinfo, cfg, phonecfg, trsmId) => {
  const url = cfg.url + "556";

  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("trsmId", trsmId);
  return postApi(url, formData);
};

export const PostApi1930 = async (
  userinfo,
  cfg,
  phonecfg,
  reqType,
  attctNo
) => {
  const url = cfg.url + "1930";

  const formData = new FormData();
  formData.append("reqType", reqType);
  formData.append("attctNo", attctNo);
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  return postApi(url, formData);
};

export const PostApi1931 = async (
  userinfo,
  cfg,
  phonecfg,
  attctNo,
  joinInfo
) => {
  const url = cfg.url + "1931";

  const formData = new FormData();
  // joinInfo
  formData.append("hpNo", joinInfo.hpNo);
  formData.append("ptBirthday", joinInfo.ptBirthday);
  formData.append("ptName", joinInfo.ptName);
  formData.append("ptNo", joinInfo.ptNo);
  formData.append("ptPhone", joinInfo.ptPhone);
  formData.append("ptSex", joinInfo.ptSex);
  formData.append("attctNo", attctNo);

  // userInfo
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  return postApi(url, formData);
};

// 공지사항
export const PostApi951 = async cfg => {
  const url = cfg.url + "951";

  const formData = new FormData();
  formData.append("noticeType", "5");
  // formData.append('pageNo', '1');
  // formData.append('pageCnt', '10');

  return postApi(url, formData);
};

// 광고
export const PostApi960 = async (phonecfg, cfg) => {
  const url = cfg.url + "960";

  const formData = new FormData();
  formData.append("mobile_yn", "Y");
  formData.append("appVer", phonecfg.version);

  return postApi(url, formData);
};

//코드조회
export const PostApi1001 = async (userinfo, cfg, phonecfg, grpCd) => {
  const url = cfg.url + "1001";

  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append("grpCd", grpCd);

  return postApi(url, formData);
};

// 혈압입력
export const PostApi1101 = async (
  userinfo,
  phonecfg,
  cfg,
  inptType,
  bpcTimeCd,
  bpcDate,
  bpcTime,
  bpcTrgt,
  bpcMemo,
  maxBp,
  minBp,
  hrtRate
) => {
  const url = cfg.url + "1101";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("inptType", inptType);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("bpcTimeCd", bpcTimeCd);
  formData.append("bpcDate", bpcDate);
  formData.append("bpcTime", bpcTime);
  formData.append("bpcTrgt", bpcTrgt);
  formData.append("bpcMemo", bpcMemo);
  formData.append("maxBp", maxBp);
  formData.append("minBp", minBp);
  formData.append("hrtRate", hrtRate);
  return postApi(url, formData);
};
// 혈압수치상태
export const PostApi1102 = async (
  userinfo,
  cfg,
  phonecfg,
  periodType,
  reqStartDate,
  reqEndDate,
  bpcTimeCd
) => {
  const url = cfg.url + "1102";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("periodType", periodType);
  formData.append("bpcTimeCd", bpcTimeCd);
  formData.append("searchFrDt", reqStartDate);
  formData.append("searchToDt", reqEndDate);
  return postApi(url, formData);
};

//  혈압그래프써머리
export const PostApi1103 = async (
  userinfo,
  cfg,
  phonecfg,
  periodType,
  reqStartDate,
  reqEndDate,
  bpcTimeCd
) => {
  const url = cfg.url + "1103";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("periodType", periodType);
  formData.append("bpcTimeCd", bpcTimeCd);
  formData.append("searchFrDt", reqStartDate);
  formData.append("searchToDt", reqEndDate);
  return postApi(url, formData);
};

// 혈압그래프
export const PostApi1104 = async (
  userinfo,
  cfg,
  phonecfg,
  periodType,
  searchFromDt,
  searchToDt,
  bpcTimeCd
) => {
  const url = cfg.url + "1104";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("periodType", periodType);
  formData.append("bpcTimeCd", bpcTimeCd);
  formData.append("searchFrDt", searchFromDt);
  formData.append("searchToDt", searchToDt);
  return postApi(url, formData);
};

//혈압/심박수 목록
export const PostApi1106 = async (
  userinfo,
  cfg,
  phonecfg,
  periodType,
  reqStartDate,
  reqEndDate,
  pageNo,
  pageCnt
) => {
  const url = cfg.url + "1106";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("periodType", periodType);
  formData.append("searchFrDt", reqStartDate);
  formData.append("searchToDt", reqEndDate);
  formData.append("pageNo", pageNo);
  formData.append("pageCnt", pageCnt);
  return postApi(url, formData);
};

//혈압/심박수 삭제
export const PostApi1107 = async (userinfo, cfg, phonecfg, seqNo) => {
  const url = cfg.url + "1107";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("seqNo", seqNo);
  return postApi(url, formData);
};

//목표혈압등록
export const PostApi1108 = async (userinfo, cfg, phonecfg, maxBp, minBp) => {
  const url = cfg.url + "1108";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("maxBp", maxBp);
  formData.append("minBp", minBp);
  return postApi(url, formData);
};

//목표혈압 조회
export const PostApi1109 = async (userinfo, phonecfg, cfg) => {
  const url = cfg.url + "1109";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  return postApi(url, formData);
};

// 복약설정입력
export const PostApi1110 = async (userinfo, cfg, phonecfg, mdcnType) => {
  const url = cfg.url + "1110";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("mdcnType", mdcnType);
  formData.append("mdcnNm", $("input[name=mdcnNameInput]").val());
  formData.append("alrmTypeCd", $("#alrmTypeCd").val());
  formData.append("mdcnCyclCd", $("#mdcnCyclCd").val());
  formData.append("mdcnCyclVal", $("#mdcnCyclVal").val());
  formData.append("mdcnCyclDtlCd", $("#mdcnCyclDtlCd").val());
  formData.append("mdcnTime", $("#mdcnTime").val());
  return postApi(url, formData);
};

// 복약설정수정
export const PostApi1111 = async (userinfo, cfg, phonecfg, mdcnType) => {
  const url = cfg.url + "1111";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("mdcnType", mdcnType);
  formData.append("mdcnNm", $("input[name=mdcnNameInput]").val());
  formData.append("alrmTypeCd", $("#alrmTypeCd").val());
  formData.append("mdcnCyclCd", $("#mdcnCyclCd").val());
  formData.append("mdcnCyclVal", $("#mdcnCyclVal").val());
  formData.append("mdcnCyclDtlCd", $("#mdcnCyclDtlCd").val());
  formData.append("mdcnTime", $("#mdcnTime").val());
  formData.append("mdcnId", $("#mdcnId").val());
  return postApi(url, formData);
};

// 복약설정삭제
export const PostApi1112 = async (
  userinfo,
  cfg,
  phonecfg,
  mdcnId,
  mdcnType
) => {
  const url = cfg.url + "1112";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("mdcnId", mdcnId);
  formData.append("mdcnType", mdcnType);
  return postApi(url, formData);
};
//복약조회
export const PostApi1113 = async (
  userinfo,
  cfg,
  phonecfg,
  searchDt,
  mdcnType
) => {
  const url = cfg.url + "1113";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("searchDt", searchDt);
  formData.append("mdcnType", mdcnType);
  return postApi(url, formData);
};
//복약 등록/취소
export const PostApi1114 = async (
  userinfo,
  cfg,
  phonecfg,
  procType,
  mdcnIds,
  mdcnDate
) => {
  const url = cfg.url + "1114";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("procType", procType);
  formData.append("mdcnIds", mdcnIds);
  formData.append("mdcnDate", mdcnDate);
  return postApi(url, formData);
};
// 복약수치상태
export const PostApi1115 = async (
  userinfo,
  cfg,
  phonecfg,
  periodType,
  searchFromDt,
  searchToDt,
  mdcnType
) => {
  const url = cfg.url + "1115";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("periodType", periodType);
  formData.append("mdcnType", mdcnType);
  formData.append("searchFrDt", searchFromDt);
  formData.append("searchToDt", searchToDt);
  return postApi(url, formData);
};

// 복약이력
export const PostApi1116 = async (
  userinfo,
  cfg,
  phonecfg,
  periodType,
  searchFromDt,
  searchToDt,
  mdcnType,
  pageNo,
  pageCnt
) => {
  const url = cfg.url + "1116";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("periodType", periodType);
  formData.append("mdcnType", mdcnType);
  formData.append("searchFrDt", searchFromDt);
  formData.append("searchToDt", searchToDt);
  formData.append("pageNo", pageNo);
  formData.append("pageCnt", pageCnt);
  return postApi(url, formData);
};

// 복약메모 등록/수정
export const PostApi1117 = async (
  userinfo,
  cfg,
  phonecfg,
  mdcnDate,
  mdcnMemo,
  mdcnType
) => {
  const url = cfg.url + "1117";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("mdcnDate", mdcnDate);
  formData.append("mdcnMemo", mdcnMemo);
  formData.append("mdcnType", mdcnType);
  return postApi(url, formData);
};
//복약설정조회
export const PostApi1118 = async (userinfo, cfg, phonecfg, mdcnType) => {
  const url = cfg.url + "1118";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken.length == 0 || phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("mdcnType", mdcnType);
  return postApi(url, formData);
};

//혈압메모 수정
export const PostApi1119 = async (userinfo, cfg, phonecfg, seqNo, bpMemo) => {
  const url = cfg.url + "1119";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("seqNo", seqNo);
  formData.append("bpcMemo", bpMemo);
  return postApi(url, formData);
};
// 혈당수정
export const PostApi1120 = async (
  userinfo,
  cfg,
  phonecfg,
  seqNo,
  bpcTimeCd,
  bpcDate,
  bpcTime,
  bpcTrgt,
  maxBp,
  minBp,
  hrtRate
) => {
  const url = cfg.url + "1120";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append("seqNo", seqNo);
  formData.append("bpcTimeCd", bpcTimeCd); // 오전(AM), 오후(PM)
  formData.append("bpcDate", bpcDate); // yyyymmdd
  formData.append("bpcTime", bpcTime); // hhmm
  formData.append("bpcTrgt", bpcTrgt); // pass
  formData.append("maxBp", maxBp);
  formData.append("minBp", minBp);
  formData.append("hrtRate", hrtRate);

  return postApi(url, formData);
};

//혈당입력
export const PostApi1201 = async (
  userinfo,
  cfg,
  phonecfg,
  inptType,
  bsDate,
  bsTime,
  mealType,
  afMealTime,
  bs,
  dvcNm,
  bsMemo
) => {
  const url = cfg.url + "1201";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("inptType", inptType);
  formData.append("bsDate", bsDate);
  formData.append("bsTime", bsTime);
  formData.append("mealType", mealType);
  formData.append("afMealTime", afMealTime);
  formData.append("bs", bs);
  formData.append("bsUnit", userinfo.bsUnit ? userinfo.bsUnit : "mg/dl");
  formData.append("dvcNm", dvcNm);
  formData.append("bsMemo", bsMemo);
  return postApi(url, formData);
};
//인슐린 입력
export const PostApi1202 = async (
  userinfo,
  cfg,
  phonecfg,
  injctDate,
  injctTime,
  mealType,
  afMealTime,
  injctForm,
  injctDose,
  injctMemo,
  injctFormDesc
) => {
  const url = cfg.url + "1202";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("injctDate", injctDate);
  formData.append("injctTime", injctTime);
  formData.append("mealType", mealType);
  formData.append("afMealTime", afMealTime);
  formData.append("injctFormCd", injctForm);
  formData.append("injctFormDesc", injctFormDesc);
  formData.append("injctDose", injctDose);
  formData.append("injctMemo", injctMemo);

  return postApi(url, formData);
};
// 혈당수치상태
export const PostApi1203 = async (
  userinfo,
  cfg,
  phonecfg,
  periodType,
  reqStartDate,
  reqEndDate,
  mealType
) => {
  const url = cfg.url + "1203";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("periodType", periodType);
  formData.append("mealType", mealType);
  formData.append("searchFrDt", reqStartDate);
  formData.append("searchToDt", reqEndDate);

  return postApi(url, formData);
};
//혈당 그래프
export const PostApi1204 = async (
  userinfo,
  cfg,
  phonecfg,
  periodType,
  searchFrDt,
  searchToDt,
  mealType
) => {
  const url = cfg.url + "1204";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("periodType", periodType);
  formData.append("mealType", mealType);
  formData.append("searchFrDt", searchFrDt);
  formData.append("searchToDt", searchToDt);
  return postApi(url, formData);
};
//혈당 목록
export const PostApi1205 = async (
  userinfo,
  cfg,
  phonecfg,
  periodType,
  reqStartDate,
  reqEndDate,
  pageNo,
  pageCnt
) => {
  const url = cfg.url + "1205";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("periodType", periodType);
  formData.append("searchFrDt", reqStartDate);
  formData.append("searchToDt", reqEndDate);
  formData.append("pageNo", pageNo);
  formData.append("pageCnt", pageCnt);
  return postApi(url, formData);
};
//혈당 삭제
export const PostApi1206 = async (
  userinfo,
  cfg,
  phonecfg,
  bsSeqNo,
  inslSeqNo
) => {
  const url = cfg.url + "1206";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("bsSeqNo", bsSeqNo);
  formData.append("inslSeqNo", inslSeqNo);
  return postApi(url, formData);
};
//목표혈당등록
export const PostApi1207 = async (
  userinfo,
  cfg,
  phonecfg,
  bfMaxBs,
  bfMinBs,
  afMaxBs,
  afMinBs
) => {
  const url = cfg.url + "1207";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  formData.append("bfMaxBs", bfMaxBs);
  formData.append("bfMinBs", bfMinBs);
  formData.append("afMaxBs", afMaxBs);
  formData.append("afMinBs", afMinBs);
  return postApi(url, formData);
};

// 목표혈당 조회
export const PostApi1208 = async (userinfo, cfg, phonecfg) => {
  const url = cfg.url + "1208";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  return postApi(url, formData);
};

// 혈당메모 수정
export const PostApi1209 = async (userinfo, cfg, phonecfg, seqNo, bsMemo) => {
  const url = cfg.url + "1209";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("seqNo", seqNo);
  formData.append("bsMemo", bsMemo);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  return postApi(url, formData);
};

export const PostApi1212 = async (
  userinfo,
  cfg,
  phonecfg,
  seqNo,
  bsDate,
  bsTime,
  mealType,
  afMealTime,
  bs
) => {
  const url = cfg.url + "1212";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append("seqNo", seqNo);
  formData.append("bsDate", bsDate);
  formData.append("bsTime", bsTime);
  formData.append("mealType", mealType);
  formData.append("afMealTime", afMealTime);
  formData.append("bs", bs);
  return postApi(url, formData);
};

export const PostApi1214 = async (
  userinfo,
  cfg,
  phonecfg,
  seqNo,
  injctDate,
  injctTime,
  mealType,
  afMealTime,
  injctForm,
  injctDose
) => {
  const url = cfg.url + "1214";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("seqNo", seqNo);
  formData.append("injctDate", injctDate);
  formData.append("injctTime", injctTime);
  formData.append("mealType", mealType);
  formData.append("afMealTime", afMealTime);
  formData.append("injctForm", injctForm);
  formData.append("injctDose", injctDose);

  return postApi(url, formData);
};

export const PostApi1215 = async (
  userinfo,
  cfg,
  phonecfg,
  seqNo,
  injctMemo
) => {
  const url = cfg.url + "1215";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("phoneToken", phonecfg.phoneToken);
  formData.append("seqNo", seqNo);
  formData.append("injctMemo", injctMemo);

  return postApi(url, formData);
};

// export const PostApi1401 = async (userinfo, cfg, phonecfg, inptType, bmiDate, bmiTime, wght, hght, BMI, SMM, bdft, vsrlft, memo) => {
export const PostApi1401 = async (
  userinfo,
  cfg,
  phonecfg,
  inptType,
  bmiDate,
  bmiTime,
  wght,
  hght,
  BMI,
  memo
) => {
  const url = cfg.url + "1401";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("inptType", inptType);
  formData.append("bmiDate", bmiDate);
  formData.append("bmiTime", bmiTime);
  formData.append("wght", wght);
  formData.append("hght", hght);
  formData.append("BMI", BMI);
  // formData.append('SMM', SMM);
  // formData.append('bdft', bdft);
  // formData.append('vsrlft', vsrlft);
  formData.append("memo", memo);
  return postApi(url, formData);
};

export const PostApi1402 = async (userinfo, cfg, phonecfg) => {
  const url = cfg.url + "1402";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  return postApi(url, formData);
};

export const PostApi1403 = async (
  userinfo,
  cfg,
  phonecfg,
  periodType,
  searchFrDt,
  searchToDt,
  pageNo,
  pageCnt
) => {
  const url = cfg.url + "1403";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("periodType", periodType);
  formData.append("searchFrDt", searchFrDt);
  formData.append("searchToDt", searchToDt);
  formData.append("pageNo", pageNo);
  formData.append("pageCnt", pageCnt);
  return postApi(url, formData);
};

export const PostApi1404 = async (userinfo, cfg, phonecfg, seqNo) => {
  const url = cfg.url + "1404";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("seqNo", seqNo);
  return postApi(url, formData);
};

export const PostApi1405 = async (
  userinfo,
  cfg,
  phonecfg,
  trgtWght,
  vrtnType
) => {
  const url = cfg.url + "1405";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("trgtWght", trgtWght);
  formData.append("vrtnType", vrtnType);
  return postApi(url, formData);
};

export const PostApi1406 = async (userinfo, cfg, phonecfg) => {
  const url = cfg.url + "1406";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  return postApi(url, formData);
};

export const PostApi1409 = async (userinfo, cfg, phonecfg, seqNo, memo) => {
  const url = cfg.url + "1409";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("seqNo", seqNo);
  formData.append("memo", memo);
  return postApi(url, formData);
};

//건강정보 조회
export const PostApi1901 = async (
  userinfo,
  cfg,
  phonecfg,
  saveStep,
  blodType,
  blodTypeDtl,
  hght,
  wght,
  bmi,
  smokYn,
  smokDtl,
  drnkYn,
  drnkDtl,
  drnkKind,
  drnkCnt,
  alrgYn,
  alrgDtl,
  mdclHistType,
  mdclHistDtl,
  mdclHistDgnssDesc,
  mdclHistDrug,
  mdclHistDrugDesc,
  fmlyHistYn,
  flmyHistDtl,
  flmyHistDtlDesc,
  hpttsBVcnt,
  hpttsAVcnt,
  pnmn13Vcnt,
  pnmn23Vcnt,
  hrpztVcnt,
  infzVcnt,
  ttnsVcnt,
  TdapVcnt,
  crvclCncrVcnt,
  hpttsATest,
  hpttsBTest,
  hpttsCTest
) => {
  const url = cfg.url + "1901";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("saveStep", saveStep);
  formData.append("blodType", blodType);
  formData.append("blodTypeDtl", blodTypeDtl);
  formData.append("hght", hght);
  formData.append("wght", wght);
  formData.append("bmi", bmi);
  formData.append("smokYn", smokYn);
  formData.append("smokDtl", smokDtl);
  formData.append("drnkYn", drnkYn);
  formData.append("drnkDtl", drnkDtl);
  formData.append("drnkKind", drnkKind);
  formData.append("drnkCnt", drnkCnt);

  formData.append("alrgYn", alrgYn);
  if (alrgYn === "Y") {
    formData.append("alrgDtl", alrgDtl);
  }
  formData.append("mdclHistYn", mdclHistType);
  formData.append("mdclHistDgnss", mdclHistDtl);
  formData.append("mdclHistDgnssDesc", mdclHistDgnssDesc);
  formData.append("mdclHistDrug", mdclHistDrug);
  formData.append("mdclHistDrugDesc", mdclHistDrugDesc);
  formData.append("fmlyHistYn", fmlyHistYn);
  formData.append("fmlyHistDtl", flmyHistDtl);
  formData.append("fmlyHistDtlDesc", flmyHistDtlDesc);

  checkParam("hpttsBVcnt", hpttsBVcnt);
  checkParam("hpttsAVcnt", hpttsAVcnt);
  checkParam("pnmn13Vcnt", pnmn13Vcnt);
  checkParam("pnmn23Vcnt", pnmn23Vcnt);
  checkParam("hrpztVcnt", hrpztVcnt);
  checkParam("infzVcnt", infzVcnt);
  checkParam("ttnsVcnt", ttnsVcnt);
  checkParam("TdapVcnt", TdapVcnt);
  checkParam("crvclCncrVcnt", crvclCncrVcnt);

  checkParam("hpttsATest", hpttsATest);
  checkParam("hpttsBTest", hpttsBTest);
  checkParam("hpttsCTest", hpttsCTest);

  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  return postApi(url, formData);

  function checkParam(key, value) {
    if (!value || value == "미접종" || value == "미검사") {
      formData.append(key, "N");
    } else if (value == "기억안남") {
      formData.append(key, "Y");
    } else {
      formData.append(key, value);
    }
  }
};

// 제증명 등록
// export const PostApi1601 = async (
//   userinfo,
//   cfg,
//   phonecfg,
//   hsptCd,
//   hsptTypeCd,
//   aplnRsnCd,
//   rqstDesc,
//   rqstRelCd,
//   rqstNm,
//   rqstNum,
//   rqstTelNo,
//   psnlInfoAgreeYn,
//   signString,
//   docTypeCd,
//   docPrice
// ) => {
//   const url = cfg.url + "1601";
//   const formData = new FormData();
//   formData.append("userToken", userinfo.userToken);
//   formData.append(
//     "phoneToken",
//     phonecfg.phoneToken === "123"
//       ? getCookie("phoneToken")
//       : phonecfg.phoneToken
//   );
//   formData.append("hsptCd", hsptCd);
//   formData.append("hsptTypeCd", hsptTypeCd);
//   formData.append("docTypeCd", docTypeCd);
//   formData.append("docPrice", docPrice);
//   formData.append("aplnRsnCd", aplnRsnCd);
//   formData.append("rqstDesc", rqstDesc);
//   formData.append("rqstRelCd", rqstRelCd);
//   formData.append("rqstNm", rqstNm);
//   formData.append("rqstNum", rqstNum);
//   formData.append("rqstTelNo", rqstTelNo);
//   formData.append("psnlInfoAgreeYn", psnlInfoAgreeYn);
//   formData.append("signString", signString);
//   return postApi(url, formData);
// };
export const PostApi1601 = async (
  userinfo,
  cfg,
  phonecfg,
  hsptCd,
  hsptTypeCd,
  aplnRsnCd,
  rqstDesc,
  rqstRelCd,
  rqstNm,
  rqstNum,
  rqstTelNo,
  psnlInfoAgreeYn,
  signString,
  docTypeCd,
  docTypeNm,
  docPrice
) => {
  const url = cfg.url + "1601";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("hsptCd", hsptCd);
  formData.append("hsptTypeCd", hsptTypeCd);
  formData.append("docTypeCd", docTypeCd);
  formData.append("docTypeNm", docTypeNm);
  formData.append("docPrice", docPrice);
  formData.append("aplnRsnCd", aplnRsnCd);
  formData.append("rqstDesc", rqstDesc);
  formData.append("rqstRelCd", rqstRelCd);
  formData.append("rqstNm", rqstNm);
  formData.append("rqstNum", rqstNum);
  formData.append("rqstTelNo", rqstTelNo);
  formData.append("psnlInfoAgreeYn", psnlInfoAgreeYn);
  formData.append("signString", signString);
  return postApi(url, formData);
};

// 제증명결제내역
export const PostApi1602 = async (
  userinfo,
  cfg,
  phonecfg,
  hsptCd,
  idCardFileNm,
  idCardEncFile,
  relFileNm,
  relEncFile
) => {
  const url = cfg.url + "1602";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("hsptCd", hsptCd);
  formData.append("idCardFileNm", idCardFileNm);
  formData.append("idCardEncFile", idCardEncFile);
  formData.append("relFileNm", relFileNm);
  formData.append("relEncFile", relEncFile);
  return postApi(url, formData);
};

// 제증명신청 대상 병원목록
export const PostApi1603 = async (userinfo, cfg, phonecfg, srchHsptNm) => {
  const url = cfg.url + "1603";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("srchHsptNm", srchHsptNm ? srchHsptNm : "");
  formData.append("lat", phonecfg.userLat);
  formData.append("long", phonecfg.userLng);
  return postApi(url, formData);
};

// 결제내역조회
export const PostApi1604 = async (
  userToken,
  cfg,
  phonecfg,
  seqNo,
  prodType
) => {
  const url = cfg.url + "1604";
  const formData = new FormData();

  formData.append("userToken", userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("seqNo", seqNo);
  formData.append("prodType", prodType);

  return postApi(url, formData);
};

// 제증명조회
export const PostApi1605 = async (
  userinfo,
  cfg,
  phonecfg,
  periodType,
  srchFrDt,
  srchToDt
) => {
  const url = cfg.url + "1605";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("periodType", periodType);
  formData.append("srchFrDt", srchFrDt);
  formData.append("srchToDt", srchToDt);

  return postApi(url, formData);
};

// 문서목록
export const PostApi1606 = async (userinfo, cfg, phonecfg, hsptCd) => {
  const url = cfg.url + "1606";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("hsptCd", hsptCd);

  return postApi(url, formData);
};

// 제증명 결제 완료/취소
export const PostApi1607 = async (
  userinfo,
  cfg,
  phonecfg,
  seqNo,
  payMth,
  payAmount,
  trnsnType,
  trnsnId,
  trnsnRslt
) => {
  const url = cfg.url + "1607";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("seqNo", seqNo);
  formData.append("payMth", payMth);
  formData.append("payAmount", payAmount);
  formData.append("trnsnType", trnsnType);
  formData.append("pgCno", trnsnId);
  // formData.append('aprvlDh', trsnDh);

  if (trnsnType == "02") {
    formData.append("aprvlRsltCd", trnsnRslt);
  }

  if (trnsnType == "05") {
    formData.append("cnclRsltCd", trnsnRslt);
  }

  return postApi(url, formData);
};

export const PostApi1608 = async (userinfo, cfg, phonecfg, seqNo) => {
  const url = cfg.url + "1608";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("seqNo", seqNo);

  return postApi(url, formData);
};

export const PostApi1702 = async (userinfo, cfg, phonecfg, seqNo) => {
  const url = cfg.url + "1702";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("seqNo", seqNo);

  return postApi(url, formData);
};

export const PostApi1703 = async (userinfo, cfg, phonecfg) => {
  const url = cfg.url + "1703";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);

  return postApi(url, formData);
};

export const PostApi1704 = async (
  userinfo,
  cfg,
  phonecfg,
  procType,
  seqNo,
  studDt,
  hsptNm,
  studNm,
  dataType,
  hsptCd
) => {
  const url = cfg.url + "1704";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("procType", procType);
  formData.append("seqNo", seqNo);
  formData.append("studDt", studDt);
  formData.append("hsptNm", hsptNm);
  formData.append("studNm", studNm);

  return postApi(url, formData);
};

export const PostApi1705 = async (
  userinfo,
  cfg,
  phonecfg,
  srchFrdt,
  srchToDt,
  hsptNm,
  hsptCd,
  srchType
) => {
  const url = cfg.url + "1705";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("srchFrDt", srchFrdt);
  formData.append("srchToDt", srchToDt);
  formData.append("hsptNm", hsptNm);
  formData.append("hsptCd", hsptCd);
  formData.append("srchType", srchType ? "Y" : "N");

  return postApi(url, formData);
};

export const PostApi1706 = async (
  userinfo,
  cfg,
  phonecfg,
  srchFrDt,
  srchToDt
) => {
  const url = cfg.url + "1706";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("srchFrDt", srchFrDt);
  formData.append("srchToDt", srchToDt);

  return postApi(url, formData);
};

//건강정보 조회
export const PostApi1902 = async (userinfo, cfg, phonecfg) => {
  const url = cfg.url + "1902";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  return postApi(url, formData);
};

// 카드관리조회
export const PostApi1910 = async (userinfo, cfg, phonecfg, cardType) => {
  const url = cfg.url + "1910";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("cardType", cardType);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  return postApi(url, formData);
};
//카드 조회
export const PostApi1911 = async (userinfo, cfg, phonecfg, cardType) => {
  const url = cfg.url + "1911";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("cardType", cardType);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  return postApi(url, formData);
};
// 카드 삭제/등록
export const PostApi1912 = async (
  userinfo,
  cfg,
  phonecfg,
  cardType,
  cardId,
  useYn
) => {
  const url = cfg.url + "1912";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("cardType", cardType);
  formData.append("cardId", cardId);
  formData.append("useYn", useYn);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  return postApi(url, formData);
};
//앱 설정 조회
export const PostApi1913 = async (userinfo, cfg, phonecfg) => {
  const url = cfg.url + "1913";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  return postApi(url, formData);
};
//앱 설정
export const PostApi1914 = async (
  userinfo,
  cfg,
  phonecfg,
  setColumn,
  setValue,
  hpKey,
  ptntNo
) => {
  const url = cfg.url + "1914";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("setColumn", setColumn);
  formData.append("setValue", setValue);
  formData.append("hpKey", hpKey);
  formData.append("ptntNo", "");
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  return postApi(url, formData);
};

export const PostApi1916 = async (
  userinfo,
  cfg,
  phonecfg,
  hpKey,
  procType,

  aplnPtntNo,
  userinfoCst
) => {
  const url = cfg.url + "1916";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("hpKey", hpKey);
  formData.append("procType", procType);

  formData.append("aplnUserNm", userinfoCst.userName);
  formData.append("aplnBirthDt", userinfoCst.birth);
  formData.append("aplnGndr", userinfoCst.sex);
  formData.append("aplnTelNo", userinfoCst.userPhone);
  formData.append("aplnPtntNo", aplnPtntNo);

  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  return postApi(url, formData);
};

//비밀번호변경
export const PostApi1915 = async (
  userinfo,
  cfg,
  phonecfg,
  email,
  currPass,
  chgPass
) => {
  const url = cfg.url + "1915";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("userId", userinfo.userId);
  formData.append("currPass", currPass);
  formData.append("chgPass", chgPass);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  return postApi(url, formData);
};

export const PostApi1920 = async (userinfo, cfg, phonecfg) => {
  const url = cfg.url + "1920";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  return postApi(url, formData);
};

export const PostApi1921 = async (userinfo, cfg, phonecfg, alrmNo) => {
  const url = cfg.url + "1921";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("alrmNo", alrmNo);
  return postApi(url, formData);
};

export const PostApi1922 = async (userinfo, cfg, phonecfg, alrmNo) => {
  const url = cfg.url + "1922";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("alrmNo", alrmNo);
  return postApi(url, formData);
};

export const PostApi1940 = async (
  userinfo,
  cfg,
  phonecfg,
  schdlType,
  srchFrDt,
  srchToDt
) => {
  const url = cfg.url + "1940";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );

  formData.append("schdlType", schdlType);
  formData.append("srchFrDt", srchFrDt);
  formData.append("srchToDt", srchToDt);

  return postApi(url, formData);
};

export const PostApi1941 = async (userinfo, cfg, phonecfg, schdlSeqNo) => {
  const url = cfg.url + "1941";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );

  let schdlSeqNoToString;

  for (let cnt = 0; cnt < schdlSeqNo.length; cnt++) {
    if (cnt === 0) {
      schdlSeqNoToString = schdlSeqNo[cnt].toString();
    } else {
      schdlSeqNoToString += "," + schdlSeqNo[cnt].toString();
    }
  }

  formData.append("schdlSeqNo", schdlSeqNoToString);

  return postApi(url, formData);
};

export const PostApi1942 = async (
  userinfo,
  cfg,
  phonecfg,
  schdlSeqNo,
  hsptCd,
  schdlNo
) => {
  const url = cfg.url + "1942";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("schdlSeqNo", schdlSeqNo);
  formData.append("hsptCd", hsptCd);
  formData.append("schdlNo", schdlNo);

  formData.append("phoneToken", phonecfg.phoneToken);

  return postApi(url, formData);
};

export const PostApi1950 = async (
  userinfo,
  cfg,
  periodType,
  srchFrDt,
  srchToDt,
  studItemCd
) => {
  const url = cfg.url + "1950";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("periodType", periodType);
  formData.append("srchFrDt", srchFrDt);
  formData.append("srchToDt", srchToDt);
  formData.append("studItemCd", studItemCd);

  return postApi(url, formData);
};

export const PostApi1951 = async (
  userinfo,
  cfg,
  studDt,
  studItemCd,
  studRslt
) => {
  const url = cfg.url + "1951";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("studDt", studDt);
  formData.append("studItemCd", studItemCd);
  formData.append("studRslt", studRslt);

  return postApi(url, formData);
};

export const PostApi1952 = async (userinfo, cfg, seqNo) => {
  const url = cfg.url + "1952";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("seqNo", seqNo);

  return postApi(url, formData);
};

export const PostApi1953 = async (userinfo, cfg, studItemCd, studRslt) => {
  const url = cfg.url + "1953";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("studItemCd", studItemCd);
  formData.append("studRslt", studRslt);

  return postApi(url, formData);
};

export const PostApi1954 = async (userinfo, cfg, studItemCd) => {
  const url = cfg.url + "1954";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("studItemCd", studItemCd);

  return postApi(url, formData);
};

export const PostApi998 = async (cfg, userDI) => {
  const url = cfg.url + "150";
  const formData = new FormData();

  formData.append("userDI", userDI);
  return postApi(url, formData);
};

export const PostApi1970 = async (userinfo, cfg, phonecfg, seqNo) => {
  const url = cfg.url + "1970";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  // formData.append("seqNo", seqNo);
  formData.append("seqNo", "");
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVers", phonecfg.version);
  formData.append("phoneToken", phonecfg.phoneToken);
  return postApi(url, formData);
};

export const PostApi1971 = async (
  userinfo,
  cfg,
  phonecfg,
  seqNo,
  appStatus
) => {
  const url = cfg.url + "1971";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("seqNo", seqNo);
  formData.append("appStatus", appStatus);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVers", phonecfg.version);
  formData.append("phoneToken", phonecfg.phoneToken);
  return postApi(url, formData);
};

export const PostApi1972 = async (userinfo, cfg, phonecfg) => {
  const url = cfg.url + "1972";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVers", phonecfg.version);
  formData.append("phoneToken", phonecfg.phoneToken);
  return postApi(url, formData);
};

export const PostApi1973 = async (userinfo, cfg, phonecfg, seqNo) => {
  const url = cfg.url + "1973";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("seqNo", seqNo);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVers", phonecfg.version);
  formData.append("phoneToken", phonecfg.phoneToken);
  return postApi(url, formData);
};

export const PostApi1974 = async (userinfo, cfg, phonecfg, phoneNumber) => {
  const url = cfg.url + "1974";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("telNo", phoneNumber);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVers", phonecfg.version);
  formData.append("phoneToken", phonecfg.phoneToken);
  return postApi(url, formData);
};

// 가족목록
export const PostApi1976 = async (userinfo, cfg, phonecfg) => {
  const url = cfg.url + "1976";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);

  return postApi(url, formData);
};

// 가족등록
export const PostApi1977 = async (
  userinfo,
  cfg,
  phonecfg,
  famzNm,
  famzBirthDt,
  famzGndr,
  famzTelNo,
  famzFileNm
) => {
  const url = cfg.url + "1977";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("famzNm", famzNm);
  formData.append("famzBirthDt", famzBirthDt);
  formData.append("famzGndr", famzGndr);
  formData.append("famzTelNo", famzTelNo);
  formData.append("famzFileNm", famzFileNm);

  return postApi(url, formData);
};

// 가족수정 & 삭제
export const PostApi1978 = async (
  userinfo,
  cfg,
  phonecfg,
  procType,
  famzSeqNo,
  famzNm,
  famzBirthDt,
  famzGndr,
  famzTelNo,
  famzFileNm
) => {
  const url = cfg.url + "1978";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);

  formData.append("procType", procType);
  formData.append("famzSeqNo", famzSeqNo);
  formData.append("famzNm", famzNm);
  formData.append("famzBirthDt", famzBirthDt);
  formData.append("famzGndr", famzGndr);
  formData.append("famzTelNo", famzTelNo);
  formData.append("famzFileNm", famzFileNm);

  return postApi(url, formData);
};

export const PostApi109 = async (
  userinfo,
  phonecfg,
  cfg,
  logType,
  procType,
  scrptTypeCd
) => {
  const url = cfg.url + "109";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("logType", logType);
  formData.append("procType", procType);
  formData.append("scrptTypeCd", scrptTypeCd);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVers", phonecfg.version);
  formData.append("phoneToken", phonecfg.phoneToken);
  formData.append("phoneModel", phonecfg.modelName);
  formData.append("phoneOSVers", phonecfg.osVer);
  return postApi(url, formData);
};

export const PostApiLoginLog = async (
  userinfo,
  phonecfg,
  cfg,
  logType,
  procType,
  scrptTypeCd
) => {
  const url = cfg.url + "loginLog";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("logType", logType);
  formData.append("procType", procType);
  formData.append("scrptTypeCd", scrptTypeCd);
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVers", phonecfg.version);
  // formData.append("phoneModel", getCookie("modelName"));
  // formData.append("phoneOSVers", getCookie("osVer"));
  formData.append("phoneModel", phonecfg.modelName);
  formData.append("phoneOSVers", phonecfg.osVer);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  return postApi(url, formData);
};

export const SendEmail = async (cfg, email, authKey) => {
  const url = cfg.mailUrl + "mail/";
  return postApiHttp(url, email, authKey);
};

export const SetPGTrsn = async (
  userinfo,
  cfg,
  aplnSeqNo,
  payMth,
  payAmount,
  prodNm,
  rsltCd,
  rsltMsg,
  authPageUrl,
  authorizationId,
  bizType
) => {
  const url = cfg.url + "setPGTransaction";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("aplnSeqNo", aplnSeqNo);
  formData.append("payMth", payMth);
  formData.append("payAmount", payAmount);
  formData.append("prodNm", prodNm);
  formData.append("rsltCd", rsltCd);
  formData.append("rsltMsg", rsltMsg);
  formData.append("authPageUrl", authPageUrl);
  formData.append("authorizationId", authorizationId);
  formData.append("bizType", bizType);

  return postApi(url, formData);
};

export const CancelPayment = async (
  userinfo,
  cfg,
  trnsnNo,
  shopOrderNo,
  pgCno,
  reviseTypeCode,
  clientIp,
  clientId
) => {
  const url = cfg.webUrl + "payment/cancel";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("trnsnNo", trnsnNo);
  formData.append("shopOrderNo", shopOrderNo);
  formData.append("pgCno", pgCno);
  formData.append("reviseTypeCode", reviseTypeCode);
  formData.append("clientIp", clientIp);
  formData.append("clientId", clientId);

  return postApi(url, formData);
};

export const ShortsUrl = async (cfg, sendUrl) => {
  const url = cfg.webUrl + "naver/shortUrl";

  const params = "sendUrl=" + sendUrl;

  return postApiToNaver(url, params);
};

export const ReverseGc = async (cfg, data) => {
  const url = cfg.webUrl + "naver/rvsGc";

  const params = "coords=" + data;

  return postApiToNaver(url, params);
};

export const KakaoMsg = async (cfg, data) => {
  const params = encodeURI(data);

  return postApiToKakao(params);
};

//  혈압그래프써머리
export const PostApiHsptList = async (
  userinfo,
  cfg,
  phonecfg,
  shareYn,
  srchHsptNm
) => {
  const url = cfg.url + "hsptList";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  formData.append("userLat", phonecfg.userLat);
  formData.append("userLng", phonecfg.userLng);

  formData.append("sharYn", shareYn);
  formData.append("srchHsptNm", srchHsptNm);
  return postApi(url, formData);
};

// 비디오 인포
export const PostApiVideoInfo = async (cfg, vdeoId, vdeoType, vdeoDtlType) => {
  const url = cfg.url + "videoInfo";
  const formData = new FormData();

  formData.append("vdeoId", vdeoId);
  formData.append("vdeoType", vdeoType);
  formData.append("vdeoDtlType", vdeoDtlType);

  return postApi(url, formData);
};

// 비디오 인포
export const PostApiPushInfo = async (cfg, seqNo) => {
  const url = cfg.url + "pushInfo";
  const formData = new FormData();

  formData.append("seqNo", seqNo);

  return postApi(url, formData);
};

// 데이터 입력(max, min) 제한수치
// 앱 실행시
export const PostApiAppStdInfo = async cfg => {
  const url = cfg.url + "appStdInfo";

  const formData = new FormData();

  formData.append("userToken", "000");

  return postApi(url, formData);
};

//  측정기기 장비 목록 조회
export const PostApiDvcList = async (phonecfg, cfg, dvcType) => {
  const url = cfg.url + "dvcList";
  const formData = new FormData();
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  formData.append("dvcType", dvcType);
  return postApi(url, formData);
};

//  측정기기 장비 조회
export const PostApi1960 = async (userinfo, phonecfg, cfg, dvcType) => {
  const url = cfg.url + "1960";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  formData.append("dvcType", dvcType);
  return postApi(url, formData);
};

//  측정기기등록/수정/삭제
export const PostApi1961 = async (
  userinfo,
  cfg,
  phonecfg,
  procType,
  dvcType,
  dvcAddType,
  mnftrCd,
  modelCd
) => {
  const url = cfg.url + "1961";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);

  formData.append("procType", procType);
  formData.append("dvcType", dvcType);
  formData.append("dvcAddType", dvcAddType);
  formData.append("mnftrCd", mnftrCd);
  formData.append("modelCd", modelCd);
  return postApi(url, formData);
};

// 내 쿠폰 목록
export const PostApi1975 = async (userinfo, cfg, adptTrgtCd, srchType) => {
  const url = cfg.url + "1975";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append("adptTrgtCd", adptTrgtCd);
  formData.append("srchType", srchType);

  return postApi(url, formData);
};

// 받을 수 있는 쿠폰 목록
export const PostApiCpnList = async (userinfo, cfg, phonecfg, adptTrgtCd) => {
  const url = cfg.url + "cpnList";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append("adptTrgtCd", adptTrgtCd);
  formData.append("autoIssueYn", "Y");

  return postApi(url, formData);
};

// 쿠폰 자동 다운로드
export const PostApiCpnDn = async (userinfo, cfg, adptTrgtCd) => {
  const url = cfg.url + "cpnDn";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append("adptTrgtCd", adptTrgtCd);
  formData.append("autoIssueYn", "Y");

  return postApi(url, formData);
};

// 서비스이용료조회(cmsnInfo)
export const PostApiCmsnInfo = async (userinfo, cfg, adptTrgtCd) => {
  const url = cfg.url + "cmsnInfo";

  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append("adptTrgtCd", adptTrgtCd);

  return postApi(url, formData);
};

// 카드관리조회
export const PostApiGetNewPoint = async (userinfo, cfg, phonecfg) => {
  const url = cfg.url + "getNewPoint";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  return postApi(url, formData);
};

export const setBKTransaction = async (
  userinfo,
  cfg,
  phonecfg,
  cardSeqNo,
  rsltCd,
  rsltMsg,
  authPageUrl,
  authorizationId
) => {
  const url = cfg.url + "setBKTransaction";
  const formData = new FormData();
  formData.append("userToken", userinfo.userToken);
  formData.append("cardSeqNo", cardSeqNo);
  formData.append("rsltCd", rsltCd);
  formData.append("rsltMsg", rsltMsg);
  formData.append("authPageUrl", authPageUrl);
  formData.append("authorizationId", authorizationId);

  formData.append(
    "phoneToken",
    phonecfg.phoneToken === "123"
      ? getCookie("phoneToken")
      : phonecfg.phoneToken
  );
  formData.append("phoneOS", phonecfg.phoneOS);
  formData.append("appVer", phonecfg.version);
  return postApi(url, formData);
};

export const getAccessToken = async (hsptCode, seqNo, cfg) => {
  const url = cfg.nftfServerUrl + "/api/token/reserve/access";

  const sendData = {
    hospitalCode: hsptCode,
    orderKey: seqNo.toString(),
  };

  return postApiToJson(url, sendData);
};

export const postTokenVarify = async (hsptCode, seqNo, token, cfg) => {
  const url = cfg.nftfServerUrl + "/api/token/verify/access";

  const sendData = {
    hospitalCode: hsptCode,
    orderKey: seqNo.toString(),
    signature: token,
    role: "0",
    identity: "0",
  };

  return postApiToJson(url, sendData);
};

export const postZoomSessionId = async (zoomSessionId, cfg) => {
  // /api/zoom/session/:sessionId encode url 2번
  const url = cfg.nftfServerUrl + "/api/zoom/sessions/";
  const zoomSessId = encodeURIComponent(encodeURIComponent(zoomSessionId));

  return postSessionCheck(url, zoomSessId);
};

// 인증번호 생성
export const PostApiGnrtAttct = async (userinfo, cfg, phonecfg, phoneNuber) => {
  const url = cfg.url + "gnrtAttct";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("telNo", phoneNuber);
  formData.append("phoneToken", phonecfg.phoneToken);

  return postApi(url, formData);
};

// 인증번호 확인
export const PostApiChkAttct = async (userinfo, cfg, phonecfg, attctNo) => {
  const url = cfg.url + "chkAttct";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("telNo", userinfo.userPhone);
  formData.append("attctNo", attctNo);
  formData.append("phoneToken", phonecfg.phoneToken);

  return postApi(url, formData);
};

// 계정통합
export const PostApiAcntIntg = async (userinfo, cfg, phonecfg, trgtUserToken) => {
  const url = cfg.url + "acntIntg";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("trgtUserToken", trgtUserToken);

  return postApi(url, formData);
};

// 계정변경
export const PostAcntChrg = async (userinfo, cfg, params) => {
  const url = cfg.url + "acntChrg";
  const formData = new FormData();

  formData.append("userToken", userinfo.userToken);
  formData.append("signUpChannel", params.signUpChannel);
  formData.append("UID", params.UID);
  formData.append("userNm", params.userNm);
  formData.append("userBirthDt", params.userBirthDt);
  formData.append("userTelNo", params.userTelNo);
  formData.append("userDI", params.userDI);
  formData.append("userEmail", params.userEmail);

  return postApi(url, formData);
};